<template>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="my-breadcrumb">
        <template v-for="item in breadcrumbs">
            <el-breadcrumb-item
                :class="[item.path ? 'clickable' : '', 'limit']"
                :key="item.id"
                :to="item.clickable ? item.path : ''"
                :title="item.title"
            >
                <a v-if="item.clickable">{{ item.title }}</a>
                <template v-else>{{ item.title }}</template>
            </el-breadcrumb-item>
        </template>
    </el-breadcrumb>
</template>
<script>
    export default {
        name: 'breadcrumb',
        props: {},
        data() {
            return {
                breadcrumbs: []
            }
        },
        watch: {
            '$store.state.menuIndex': {
                handler(val) {
                    if (val) {
                        let breadcrumbs = this.handleBreadcrumb(val)
                        breadcrumbs = this.handleNestedPage(breadcrumbs)
                        this.breadcrumbs = breadcrumbs
                    } else {
                        this.breadcrumbs = []
                    }
                }
            },
            '$route.query': {
                handler() {
                    let breadcrumbs = this.handleBreadcrumb(this.$store.state.menuIndex)
                    breadcrumbs = this.handleNestedPage(breadcrumbs)
                    this.breadcrumbs = breadcrumbs
                }
            }
        },
        mounted() {
            let breadcrumbs = this.handleBreadcrumb(this.$store.state.menuIndex)
            breadcrumbs = this.handleNestedPage(breadcrumbs)
            this.breadcrumbs = breadcrumbs
        },
        methods: {
            handleBreadcrumb(currentMenuName) {
                if (!currentMenuName) {
                    return []
                }
                let breadcrumbs = []
                let menuNames = sessionStorage.getItem('menu_names') || '[]'
                menuNames = JSON.parse(menuNames)
                let routesNames = sessionStorage.getItem('routes_names') || '[]'
                routesNames = JSON.parse(routesNames)
                if (menuNames.includes(currentMenuName)) {
                    //携带左侧导航信息
                    let menuList = sessionStorage.getItem('menuList') || '[]'
                    menuList = JSON.parse(menuList)
                    breadcrumbs = this.getMenuBreadcrumb(menuList, currentMenuName)
                    //设置嵌套页面面包屑
                    if (this.$route.query._breadcrumb) {
                        breadcrumbs.push({ id: 77777777777777, title: this.$route.query._breadcrumb, isNested: true })
                    }
                } else {
                    //不携带左侧导航信息 (目前结构统一为单独的页面)
                    let metched = this.$route.matched
                    for (let index = 0; index < metched.length; index++) {
                        const element = metched[index]
                        if (currentMenuName == element.name) {
                            breadcrumbs.push({ id: 666666666666, title: element.meta.name })
                        }
                    }
                }
                let firstBreadcrumb = breadcrumbs[0]
                if (firstBreadcrumb && firstBreadcrumb.group && firstBreadcrumb.group != '#UNCLASSIFIED') {
                    breadcrumbs.unshift({ id: 8888888888888, title: firstBreadcrumb.group })
                }
                return breadcrumbs
            },
            /**
             * 获取左侧导航菜单中，对应的本地页面路由 name 数组
             */
            getMenuBreadcrumb(menuList = [], currentMenuName, parentBreadcrumb = {}) {
                let names = []
                for (let index = 0; index < menuList.length; index++) {
                    const element = menuList[index]
                    if (element.leaf == 0) {
                        parentBreadcrumb = {
                            id: element.id,
                            title: element.alias || element.name,
                            group: element.group
                        }
                    }
                    if (element.submenuList && element.submenuList.length > 0) {
                        names = names.concat(
                            this.getMenuBreadcrumb(element.submenuList, currentMenuName, parentBreadcrumb)
                        )
                    }
                    //判断是否未子节点, 并且存在于本地 routes 中
                    if (element.leaf == 1 && currentMenuName == element.url) {
                        names.push(parentBreadcrumb)
                        let breadcrumb = { id: element.id, title: element.alias || element.name }
                        if (element.url) {
                            breadcrumb.path = { name: element.url, query: { _s: 1 } }
                        }
                        names.push(breadcrumb)
                        return names
                    }
                }
                return names
            },
            handleNestedPage(breadcrumbs = []) {
                if (breadcrumbs && breadcrumbs.length >= 2) {
                    if (breadcrumbs[breadcrumbs.length - 1].isNested) {
                        breadcrumbs[breadcrumbs.length - 2].clickable = true
                    }
                }
                return breadcrumbs
            }
        }
    }
</script>
<style scoped>
    .my-breadcrumb >>> .limit span {
        display: inline-block;
        max-width: 140px;
        white-space: nowrap;
        word-wrap: break-word;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .my-breadcrumb >>> .limit:last-child span {
        max-width: 200px;
    }

    .el-breadcrumb {
        float: left;
        line-height: 50px;
    }
    .el-breadcrumb__inner a {
        cursor: auto;
    }
    .my-breadcrumb >>> .el-breadcrumb__item {
        display: flex;
        align-items: center;
    }
    .my-breadcrumb >>> .el-breadcrumb__item.clickable .el-breadcrumb__inner a {
        color: #303133;
        font-weight: 700;
        text-decoration: none;
        transition: color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        cursor: pointer !important;
    }
    .my-breadcrumb >>> .el-breadcrumb__item.clickable .el-breadcrumb__inner a:hover {
        color: #409eff;
    }
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb.vue